import { PrimaryButton } from "@/components/Buttons/PrimaryButton";
import { Button } from "@/components/ui/button";
import { usePhoneNumberActivationCode } from "@/hooks/usePhoneNumberActivationCode";
import { usePhoneNumberVerify } from "@/hooks/usePhoneNumberVerify";
import { useCountDown } from "@roman/shared/hooks/useCountDown";
import { addSeconds } from "date-fns";
import { useState } from "react";
// import { ExclamationMarkIcon } from "@/components/Icons/ExclamationMarkIcon";

interface CodeInputPageProps {
  phoneNumber: string;
  onNextStep: () => void;
}

export const CodeInputPage = ({ phoneNumber, onNextStep }: CodeInputPageProps) => {
  const [isValid, setIsValid] = useState(true);
  const [code, setCode] = useState("");
  const [endTime, setEndTime] = useState<Date>(addSeconds(new Date(), 60));
  const { deadlineTime: remainingTime, isOver } = useCountDown(endTime, "seconds");
  const { trigger } = usePhoneNumberVerify();
  const { trigger: triggerActivationCode } = usePhoneNumberActivationCode();

  // Use this to call useCase to authenticate user.
  const onError = () => {
    setIsValid(false);
  };

  // Change this function to call usecase to verify code.
  const verifyCode = () => {
    trigger({ activationCode: code })
      .then(() => {
        onNextStep();
      })
      .catch(onError);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (/^\d{0,6}$/.test(value)) {
      setCode(value);
    }
  };

  const handleResend = () => {
    // Usecase should be called here.
    triggerActivationCode({ phoneNumber }).then(() => {
      const newEndTime = addSeconds(new Date(), 60);
      setEndTime(newEndTime);
    });
  };

  return (
    <>
      <h1 className="text-2xl mb-5 font-semibold text-center text-black">認証コードを入力</h1>
      <p className="text-center text-dark-gray">SMSに届いた6桁の認証コードを入力してください。</p>
      <div className="sm:w-[450px] mt-10 flex flex-col mx-auto justify-center">
        <input
          type="number"
          value={code}
          inputMode="numeric"
          placeholder="認証コードを入力"
          className={`p-3 border rounded-lg focus:outline-none [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none ${
            !isValid ? "border-red focus:border-red" : "border-input focus:border-primary"
          }`}
          maxLength={6}
          onChange={handleInputChange}
        />
        {/* {!isError && (
          <div className="flex items-center gap-1 mt-1">
            <ExclamationMarkIcon />
            <p className="text-red-500 text-sm mt-2">ERROR MESSAGE</p>
          </div>
        )} */}
        <div className="mt-8 flex flex-col items-center justify-center">
          <Button
            variant="outline"
            onClick={handleResend}
            disabled={!isOver}
            className={`w-[150px] items-center px-4 py-3 rounded-lg ${!isOver ? "border-gray" : "border-primary"}`}
          >
            <span className={`font-bold w-full text-center ${isOver && "text-primary"}`}>
              {!isOver ? `${remainingTime}s` : "コードを再送する"}
            </span>
          </Button>
          <p className="mt-2 text-sm text-dark-gray">上記の時間内に届かない場合、コードを再送できます。</p>
        </div>
        <PrimaryButton disabled={code.length !== 6} className="mt-14" text="次へ" onClick={verifyCode} />
      </div>
    </>
  );
};
